import type * as ngCdkOverlay from '@angular/cdk/overlay'
import type * as ents from '@attain-apps/entities'

export interface State {
  /**
   * The process for doing a check-in is:
   * 1. Providing an initial emoji reaction to give a quick sense on how we're
   *    feeling in the moment
   * 2. Filling out the full check-in
   */
  checkInStage?: 'current-mood' | 'full-check-in'
  /**
   * Has the user provided a check-in yet today?
   */
  eligibleForDailyCheckIn: boolean
  /** @see {@link stage} */
  checkInCurrentMood?: string
  /**
   * Values available for {@link checkInCurrentMood}
   */
  checkInCurrentMoodCandidates: readonly string[]
  /**
   * Indicates the user wants to provide information that does not necessarily
   * pertain to the provided prompt
   */
  ignoreCheckInPrompt: boolean
  // NOTE: this is done as a callback since we don't want `origin` to be frozen
  // by NgRx
  checkInSourcePosition?: () => {
    readonly origin:
      | ngCdkOverlay.CdkOverlayOrigin
      | ngCdkOverlay.FlexibleConnectedPositionStrategyOrigin
    readonly offsetX?: number
    readonly offsetY?: number
  }
  checkIn?: ents.core.summit.CheckIn
  checkInIsLoading: boolean
  checkInError?: Error
  response?: string
  responseToTheResponse?: string
  responseToTheResponseIsLoading: boolean
  responseToTheResponseError?: Error
  feed: readonly ents.core.summit.CheckIn.Response[]
  feedSearchQuery?: string
  feedIsLoading: boolean
  feedError?: Error
}
export namespace State {
  export const INITIAL: State = {
    checkInCurrentMoodCandidates: [
      '😊',
      '😔',
      '😐',
      '😤',
      '😵‍💫',
      '🤔',
      '😴',
      '⚠️',
      '🎉',
    ],
    checkInIsLoading: false,
    eligibleForDailyCheckIn: false,
    feed: [],
    feedIsLoading: false,
    ignoreCheckInPrompt: false,
    responseToTheResponseIsLoading: false,
  }
}
